/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalTitle: {
    id: 'searchChoiceModal.modalTitle',
    defaultMessage: 'Set up a new search integration'
  },
  modalEditTitle: {
    id: 'searchChoiceModal.modalEditTitle',
    defaultMessage: 'Edit an existing search integration'
  },
  modalEditElasticsearch: {
    id: 'searchChoiceModal.modalEditElasticsearch',
    defaultMessage: 'Elasticsearch is currently configured.'
  },
  modalEditMilvus: {
    id: 'searchChoiceModal.modalEditMilvus',
    defaultMessage: 'Milvus is currently configured.'
  },
  modalEditDiscovery: {
    id: 'searchChoiceModal.modalEditElasticsearch',
    defaultMessage: 'Watson Discovery is currently configured.'
  },
  modalEditCustomService: {
    id: 'searchChoiceModal.modalEditCustomService',
    defaultMessage: 'Custom service is currently configured.'
  },
  modalEditWarning: {
    id: 'searchChoiceModal.modalEditWarning',
    defaultMessage:
      'Only one kind of search integration can be set up per environment. If you choose a new type of search, your current search configuration will be replaced upon saving.'
  },
  elasticCardTitle: {
    id: 'searchChoiceModal.elasticCardTitle',
    defaultMessage: 'Elasticsearch'
  },
  elasticCardDescription: {
    id: 'searchChoiceModal.elasticCardDescription',
    defaultMessage: 'Connect to an existing Elasticsearch instance.'
  },
  milvusCardTitle: {
    id: 'searchChoiceModal.elasticCardTitle',
    defaultMessage: 'Milvus'
  },
  milvusCardDescription: {
    id: 'searchChoiceModal.elasticCardDescription',
    defaultMessage: 'Connect to an existing Milvus instance.'
  },
  watsonDiscoveryTitle: {
    id: 'searchChoiceModal.watsonDiscoveryTitle',
    defaultMessage: 'Watson Discovery'
  },
  watsonDiscoveryDescription: {
    id: 'searchChoiceModal.watsonDiscoveryDescription',
    defaultMessage: 'Connect to an existing Watson Discovery instance.'
  },
  recommendedTag: {
    id: 'searchChoiceModal.recommendedTag',
    defaultMessage: 'RECOMMENDED'
  },
  cancel: {
    id: 'searchChoiceModal.cancel',
    defaultMessage: 'Cancel'
  },
  customServiceTitle: {
    id: 'searchChoiceModal.customServiceTitle',
    defaultMessage: 'Custom service'
  },
  customServiceDescription: {
    id: 'searchChoiceModal.customServiceDescription',
    defaultMessage:
      'Connect to an existing service that will retrieve documents from your content management service.'
  },
  learnMore: {
    id: 'searchChoiceModal.learnMore',
    defaultMessage: 'Learn more'
  }
});
